import { render, staticRenderFns } from "./WhatsappV3WarningBanner.vue?vue&type=template&id=59c87ab6&scoped=true"
import script from "./WhatsappV3WarningBanner.vue?vue&type=script&lang=js"
export * from "./WhatsappV3WarningBanner.vue?vue&type=script&lang=js"
import style0 from "./WhatsappV3WarningBanner.vue?vue&type=style&index=0&id=59c87ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c87ab6",
  null
  
)

export default component.exports